import React from "react";

import { Box } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const CallStatus = ({ status, size = "10px" }) => {
  const { callStatus } = useLocalization();

  return (
    <Box
      sx={{
        backgroundColor: callStatus[status].color,
        width: size,
        height: size,
        borderRadius: "50%",
      }}
    ></Box>
  );
};

export default CallStatus;
